/**
 * 内容注册表 - 管理所有帮助文档和说明内容
 * 用于统一管理markdown内容的路径、标题和描述
 */

export const CONTENT_REGISTRY = {
    // 航班计划相关
    FLIGHT_SCHEDULE: {
        IMPORT_DATES: {
            path: "help/2025-7-23_flight-schedule-import-dates-2.md",
            title: "导入航班日期选择说明",
            description: "详细说明导入航班功能中两个日期选择器的区别和用途",
            category: "flight-schedule",
            tags: ["导入", "日期选择", "航班计划"],
        },
        FILTER_FEATURE: {
            path: "help/2025-7-23_flight-schedule-filter.md",
            title: "航班筛选功能说明",
            description: "详细介绍航班编排列表中的筛选功能及使用方法",
            category: "flight-schedule",
            tags: ["筛选", "过滤", "航班列表"],
        },
        MATCH_SETTINGS: {
            path: "help/2025-7-23_flight-match-settings.md",
            title: "航班匹配设置说明",
            description: "详细介绍航班对比中匹配设置的各项参数含义和使用方法",
            category: "flight-schedule",
            tags: ["匹配设置", "对比功能", "航班匹配"],
        },
        ROUTE_BINDING: {
            path: "help/2025-08-22_flight-route-binding.md",
            title: "航段选择与航路绑定功能说明",
            description: "详细介绍航段选择器和自动航路绑定功能的使用方法",
            category: "flight-schedule",
            tags: ["航段选择", "航路绑定", "自动匹配", "轮档时间"],
        },
        MARKDOWN_TEST: {
            path: "help/markdown-test.md",
            title: "Markdown功能测试",
            description: "测试各种Markdown功能的渲染效果",
            category: "flight-schedule",
            tags: ["测试", "Markdown", "表格"],
        },
    },

    // 航班运营相关
    FLIGHT_OPERATION: {
        // 可以在这里添加更多运营相关的帮助内容
    },

    // 系统功能相关
    SYSTEM: {
        OVERVIEW: {
            path: "help/system-overview.md",
            title: "系统概览",
            description: "FlyMeta航班管理系统的功能概览和使用指南",
            category: "system",
            tags: ["系统概览", "快速开始", "功能介绍"],
        },
        DASHBOARD_NAVIGATION: {
            path: "help/dashboard-navigation.md",
            title: "系统导航说明",
            description: "介绍如何使用顶部Logo快速返回仪表盘",
            category: "system",
            tags: ["导航", "Logo", "首页"],
        },
        DASHBOARD_LAYOUT_EDIT: {
            path: "help/dashboard-layout-edit.md",
            title: "布局编辑说明",
            description: "介绍如何调整工作台布局",
            category: "system",
            tags: ["布局", "拖拽", "调整大小"],
        },
    },
};

/**
 * 根据路径获取内容配置
 * @param {string} contentPath - 内容路径
 * @returns {Object|null} 内容配置对象
 */
export const getContentConfig = (contentPath) => {
    const findContent = (obj) => {
        for (const key in obj) {
            if (typeof obj[key] === "object") {
                if (obj[key].path === contentPath) {
                    return obj[key];
                }
                const found = findContent(obj[key]);
                if (found) return found;
            }
        }
        return null;
    };

    return findContent(CONTENT_REGISTRY);
};

/**
 * 获取所有内容列表
 * @param {string} category - 可选的分类筛选
 * @returns {Array} 内容列表
 */
export const getAllContent = (category = null) => {
    const contents = [];

    const collectContent = (obj) => {
        for (const key in obj) {
            if (typeof obj[key] === "object") {
                if (obj[key].path) {
                    if (!category || obj[key].category === category) {
                        contents.push(obj[key]);
                    }
                } else {
                    collectContent(obj[key]);
                }
            }
        }
    };

    collectContent(CONTENT_REGISTRY);
    return contents;
};

/**
 * 获取文档的显示名称
 * @param {string} contentPath - 文档路径
 * @returns {string} 显示名称
 */
export const getDocumentDisplayName = (contentPath) => {
    const config = getContentConfig(contentPath);
    return config ? config.title : contentPath;
};
